import { render, staticRenderFns } from "./mycollections.vue?vue&type=template&id=b34c2f88&scoped=true&"
import script from "./mycollections.vue?vue&type=script&lang=js&"
export * from "./mycollections.vue?vue&type=script&lang=js&"
import style0 from "./mycollections.vue?vue&type=style&index=0&id=b34c2f88&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34c2f88",
  null
  
)

export default component.exports